/**
 * 校验文档 ID（这里指地址栏里边的加密 ID）
 * 对于文档 ID 的判断，不需要根据 tdocs 还是 wecom 的环境来判断文档的规则，因为两边都可能存在两种规则的 ID
 * - wecom 端可能有 tdocs 风格的文档 ID ，因为部分老的 toB 文档从 tdocs 迁移至 wecom
 * - tdocs 端可能有 wecom 风格的文档 ID ，因为 PO 品类的 toB 合作还未完成，目前是在 wecom 创建文档后在 tdocs 打开
 */
/**
 * 判断 ID 是否是 wecom 风格的文档 ID，不做合法性校验
 */
export var isBStyleEncId = function (encId) { return /^((w2|w3|e2|e3|s3|p3|c2|c3|m3|f3)_)[-\w]+$/.test(encId); };
/**
 * 判断 ID 是否是 tdocs 风格的文档 ID，不做合法性校验
 */
export var isCStyleEncId = function (encId) { return /^[ABCD][a-zA-Z0-9]+$/.test(encId); };
/**
 * 判断是否是文档 ID，不做合法性校验
 */
export var isValidEncId = function (encId) { return isCStyleEncId(encId) || isBStyleEncId(encId); };
